module.exports = __webpack_public_path__ + "static/Ogg-Italic-6e2b21edda2a4d1dfa59af83fe7b7c2d.woff2";